export default "__VITE_ASSET__LyEYG7TV__"